<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">
        <div class="container-fluid">
          <div class="row business-item-wrapper">
            <div class="business-item-content col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <div class="content" @click="handleClick" @mouseout="handleMouseOut('system')" @mouseover="handleMouseOver('system')">
                <img :src="systemImg" alt="系统建设" />
                <p class="content-title">系统建设</p>
                <p class="content-text">提供固定资产全生满周期解决方案帮忙您精细化管理资产，分入账与非入账模式，方便与财务对账的同时，亦符合实物管理的特性。</p>
              </div>
            </div>
            <div class="business-item-content col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <div class="content" @click="handleClick" @mouseout="handleMouseOut('service')" @mouseover="handleMouseOver('service')">
                <img :src="serviceImg" alt="决算服务" />
                <p class="content-title">决算服务</p>
                <p class="content-text">
                  适合行政事业单位的财务系统，兼容最新政府财务制度和以前的行政财务制度同时并存，可以上传电子附件并支持查阅打印等，同时可以作为财务电子凭证库管理系统使用。
                </p>
              </div>
            </div>
            <div class="business-item-content col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <div class="content" @click="handleClick" @mouseout="handleMouseOut('counselor')" @mouseover="handleMouseOver('counselor')">
                <img :src="counselorImg" alt="顾问服务" />
                <p class="content-title">顾问服务</p>
                <p class="content-text">为您单位提供全面的财务问题，单位内控问题等专业的咨询服务</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <contact-item />
  </div>
</template>
<script>
import ContactItem from "../components/contact/contactItem.vue";
export default {
  name: "Contact",
  components: {
    ContactItem,
  },
  data() {
    return {
      systemImg: require("../assets/home/system.png"),
      serviceImg: require("../assets/home/service.png"),
      counselorImg: require("../assets/home/counselor.png"),
    };
  },
  methods: {
    handleMouseOut(key) {
      this[`${key}Img`] = require(`../assets/home/${key}.png`);
    },
    handleMouseOver(key) {
      this[`${key}Img`] = require(`../assets/home/${key}2.png`);
    },
    handleClick(){
      this.$router.push({
        path:'/productPresentation'
      })
    }
  },
};
</script>
<style scoped>
.business-item-content {
  padding: 20px 62px 56px 62px;
}
.business-item-content > .content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  height: 230px;
  cursor: pointer;
}
.business-item-content > .content:hover {
  background-color: #4677e3;
}
.business-item-content > .content > img {
  width: 48px;
  height: 48px;
}
.business-item-content > .content > .content-title {
  font-size: 16px;
  color: #525252;
  font-weight: 600;
  margin-top: 4px;
}
.business-item-content > .content > .content-text {
  font-size: 12px;
  font-weight: 400;
  color: #525252;
  line-height: 20px;
  margin-top: 10px;
  width: 100%;
}
.business-item-content > .content:hover > .content-title,
.business-item-content > .content:hover > .content-text {
  color: #ffffff;
}
@media (min-width: 768px) {
  .business-item-wrapper {
    display: flex;
    justify-content: space-between;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/contact.vue